export default [
    {
        text: 'Folio',
        value: 'id',
    },
    {
        text: 'Fecha',
        value: 'realPayDate',
        format: 'date',
    },
    // {
    //     text: 'Monto a pagar',
    //     value: 'amount',
    // },
    {
        text: 'Cancelado',
        value: 'paidAmount',
        format: 'currency',
    },
    {
        text: 'Medio de Pago',
        value: 'paymentMathod',
    },
    // {
    //     text: 'Saldo',
    //     value: 'balance',
    // },
]
